export const VendorUploadStatus = {
  REQUIRED: 'Required',
  REJECTED: 'Rejected',
  UPLOADED: 'Uploaded',
  EXPIRED: 'Expired',
}

export const Currency = {
  HKD: 'HKD',
  MOP: 'MOP',
  USD: 'USD',
  EUR: 'EUR',
  CNY: 'CNY',
}

export const SiemensRFQStatusOptions = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}
